<template>
  <div class="details">
    <div class="flex">
      <div>
        <form-title>{{ title }}</form-title>
      </div>
      <div>
        <el-button
          v-if="data.courseScheduleName === null"
          type="primary"
          @click="goHistory"
        >
          查看历史课程表
        </el-button>
        <el-button
          v-if="data.courseScheduleName === null"
          type="primary"
          @click="openTplDialog"
        >
          课程表模板维护
        </el-button>
        <el-button
          v-if="data.courseScheduleName === null"
          type="primary"
          @click="openScheduleDialog"
        >
          复制课程表
        </el-button>
        <div v-else>
          <el-button
            type="primary"
            @click="openScheduleDialog"
          >
            编辑课程表
          </el-button>
          <el-button
            type="default"
            @click="deletedSchedule"
          >
            删除课程表
          </el-button>
        </div>
      </div>
    </div>
    <div class="table">
      <div class="title">
        <span>{{ data.courseScheduleName?data.courseScheduleName: '课程表模板' }}</span>
      </div>
      <el-scrollbar>
        <div
          v-if="data.courseScheduleName"
          class="header"
        >
          <span>日期</span>
          <span
            v-for="date in data.dateList"
            :key="date.id"
          >{{ $time(Number(date.scheduleDate)).format('YYYY/MM/DD') }}</span>
        </div>
        <div class="content">
          <div class="row">
            <span>
              上午
            </span>
            <span
              v-for="amItem in data.dateList"
              :key="amItem.dateIndexId"
            >
              <el-tooltip
                v-if="formatContent(amItem.amContent).length >= 10"
                effect="dark"
                :content="formatContent(amItem.amContent)"
                placement="top-start"
              >
                <div>{{ untils.substr(formatContent(amItem.amContent), 10) }}</div>
              </el-tooltip>
              <div v-else>
                {{ formatContent(amItem.amContent) }}
              </div>
            </span>
          </div>
          <div class="row">
            <span>
              下午
            </span>
            <span
              v-for="pmItem in data.dateList"
              :key="pmItem.dateIndexId"
            >
              <el-tooltip
                v-if="formatContent(pmItem.pmContent).length >= 10"
                effect="dark"
                :content="formatContent(pmItem.pmContent)"
                placement="top-start"
              >
                <div>{{ untils.substr(formatContent(pmItem.pmContent), 10) }}</div>
              </el-tooltip>
              <div v-else>
                {{ formatContent(pmItem.pmContent) }}
              </div>
            </span>
          </div>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
// import axClient from '@/services';
import formTitle from '@/components/common/formTitle.vue';
import untils from '@/util';

export default {
  name: 'Schedule',
  components: { formTitle },
  props: {
    type: {
      type: String,
      default: () => 'tpl',
    },
    title: {
      type: String,
      default: () => '课程表模板',
    },
    data: {
      type: Object,
      default: () => ({ courseScheduleName: null, dateList: [] }),
    },
  },
  data() {
    return {
      untils,
    };
  },
  watch: {
    data(list) {
      console.log(list);
    },
  },
  mounted() {
    // console.log(this.data);
  },
  methods: {
    openTplDialog() {
      this.$emit('openTplDialog');
    },
    openScheduleDialog() {
      this.$emit('openScheduleDialog', this.data);
    },
    deletedSchedule() {
      this.$emit('deletedSchedule', this.data);
    },
    formatContent(item) {
      if (this.data.courseScheduleName === null) {
        if (item && item.chapterList) {
          return item.chapterList.map((v) => v.chapterName).join(',');
        }
      } else if (item) {
        return item.classContent ? item.classContent : '无';
      }
      return '无';
    },
    // 查看历史课程表
    goHistory() {
      this.$emit('goHistory');
    },
  },
};
</script>
<style lang="scss" scoped>
.details {
  margin-top: 20px;
  .title{
    border-top: 1px solid rgba($--base-color-black, $alpha: 0.1);
    display: flex;
    justify-content: center;
    border-bottom: 1px solid rgba($--base-color-black, $alpha: 0.1);
    border-left: 1px solid rgba($--base-color-black, $alpha: 0.1);
    text-align: center;
    span{
      padding: 18px 23px;
      display: inline-flex;
      font-size: 12px;
      font-weight: 500px;
      align-items: center;
      justify-content: center;
      }
  }
  .table{
     border-left: 1px solid rgba($--base-color-black, $alpha: 0.1);
    border-right: 1px solid rgba($--base-color-black, $alpha: 0.1);
  }
  // .content,{
  //   overflow-y: auto;
  // }
  .header,
  .content .row {
    display: flex;
    padding-left: 80px;
    span {
      flex: 1;
      min-width: 200px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 18px 23px;
      border-right: 1px solid rgba($--base-color-black, $alpha: 0.1);
      border-bottom: 1px solid rgba($--base-color-black, $alpha: 0.1);
      font-size: 12px;
      min-height: 54px;
      &:last-child {
        border-right-width: 0;
      }
      &:first-child {
        position: absolute;
        left: 0;
        min-width: 80px;
        max-width: 90px;
        font-weight: 600;
        border-right-width: 1px;
        background: #ffffff;
        z-index: 9;
      }
    }
  }
}
</style>
